import { render, staticRenderFns } from "./CaLabelMonto.vue?vue&type=template&id=4145f508"
import script from "./CaLabelMonto.vue?vue&type=script&lang=js"
export * from "./CaLabelMonto.vue?vue&type=script&lang=js"
import style0 from "./CaLabelMonto.vue?vue&type=style&index=0&id=4145f508&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports